import axios from 'axios'
import qs from 'qs'

const { REACT_APP_REST_API_URL, REACT_APP_REST_API_KEY } = process.env

const publicHttp = axios.create({
	baseURL: `${REACT_APP_REST_API_URL}`,
	paramsSerializer(params) {
		return qs.stringify(params, { indices: false })
	},
	headers: {
		'x-api-key': REACT_APP_REST_API_KEY,
		'Content-Type': 'application/json',
	},
})

export default publicHttp
